import { ReactNode } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { IMultipleAutocompleteOption } from 'components/common/controller-wrapper'
import {
  BidSpreadAnalysisJobValueFilter,
  BidSpreadAnalysisPeriod,
  BidSpreadAnalysisView,
} from 'components/reports/Metrics/constants/BidSpreadAnalysis'
import { VehicleTypeFilter } from 'generated/graphql'

export interface BidSpreadAnalysisFilterValues {
  period: BidSpreadAnalysisPeriod
  customStart: Date | null
  customEnd: Date | null
  selectedServiceCodes: IMultipleAutocompleteOption[]
  vehicleType: VehicleTypeFilter
  view: BidSpreadAnalysisView
  jobValueFilter: BidSpreadAnalysisJobValueFilter
  customMinJobValue: string
  customMaxJobValue: string
}

export const BID_SPREAD_ANALYSIS_DEFAULT_FILTERS: BidSpreadAnalysisFilterValues = {
  period: 'last30',
  customStart: null,
  customEnd: null,
  selectedServiceCodes: [],
  vehicleType: VehicleTypeFilter.All,
  view: 'absolute',
  jobValueFilter: 'all',
  customMinJobValue: '',
  customMaxJobValue: '',
}

interface IProps {
  children: ReactNode
}

export const BidSpreadAnalysisFilterCriteria = ({ children }: IProps) => {
  const methods = useForm<BidSpreadAnalysisFilterValues>({
    defaultValues: BID_SPREAD_ANALYSIS_DEFAULT_FILTERS,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
